/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";
import { TokenStorage } from "../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const ProductLocationService = {
  /**
   * Get Screen data
   *
   * */
  async getByRecordId(recordId) {
    const requestScreenData = {
      url: "api/ProductBin",
      expand: "Product($select=Code,Description1,IsKit)", // ,BinLocation($select=Code,Location),Branch($select=Code,Description)
      top: "1",
      filter: `RecordId eq ${recordId}`,
    };
    return await ApiService.oDataGet(requestScreenData);
  },

  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
  async save(mode, productBin) {
    var payload = productBin;
    var url = "api/ProductBin";

    if (mode == "create") {
      return await ApiService.post(url, payload, "Guid");
    } else {
      return await ApiService.patch(url, productBin.RecordId, payload, "Guid");
    }
  },

  async delete(productBin) {
    var url = "api/ProductBin";

    return await ApiService.delete(url, productBin.RecordId, "Guid");
  },

  async getDefaultBinLocation(BranchCode, ProductCode) {
    const requestScreenData = {
      url: "api/ProductBin",
      // expand: "Product($select=Code,Description1)", //,BinLocation($select=Code,Location),Branch($select=Code,Description)
      top: "1",
      filter: `IsDefault eq 'Y' and BranchCode eq '${BranchCode}' and ProductCode eq '${ProductCode}'`,
    };
    return await ApiService.oDataGet(requestScreenData);
  },

  async getCustomData(params) {

    const requestScreenData = {
      url: "api/" + params.url,
      filter: params.filter,
    };

    return await ApiService.oDataGet(requestScreenData);
  }

};

export { ProductLocationService };
